import { CardStore } from '../components/Card/stores/CardStore.js';
import { ColumnSelectorStore } from '../components/ColumnSelector/stores/ColumnSelectorStore.js';
import { TableStore } from '../components/Table/stores/TableStore.js';
import { TStoreContext } from '../models/app/TStoreContext.js';

export function setupStoreContext(storeContext: TStoreContext) {
	const manifest = storeContext.manifest;
	storeContext.set('cardStore', new CardStore(storeContext, manifest));
	storeContext.set('tableStore', new TableStore(storeContext, manifest));
	storeContext.set('columnSelectorStore', new ColumnSelectorStore(storeContext, storeContext.manifest));
	/* [Component: stores] */
}
